export const createCustomStatusOptions = (originalStatusOptions: any[]) => {
  const customStatusOptions = [
    { value: "open_and_in_progress", label: "Open & In-Progress" },
    { value: "open", label: "Open" },
    { value: "in_progress", label: "In Progress" },
    { value: "completed", label: "Completed" },
  ];

  const statusMapping = {
    open_and_in_progress: originalStatusOptions
      ?.filter(
        (option) =>
          option.label.toLowerCase().includes("open") &&
          option.label.toLowerCase().includes("progress") &&
          option.label.toLowerCase().includes("&")
      )
      ?.map((option) => option.value),
    open: originalStatusOptions
      ?.filter(
        (option) =>
          (option.label.toLowerCase().includes("open") ||
            option.label.toLowerCase().includes("new") ||
            option.label.toLowerCase().includes("pending")) &&
          !option.label.toLowerCase().includes("&")
      )
      ?.map((option) => option.value),
    in_progress: originalStatusOptions
      ?.filter(
        (option) =>
          (option.label.toLowerCase().includes("progress") ||
            option.label.toLowerCase().includes("processing") ||
            option.label.toLowerCase().includes("reviewing")) &&
          !option.label.toLowerCase().includes("&")
      )
      ?.map((option) => option.value),
    completed: originalStatusOptions
      ?.filter(
        (option) =>
          option.label.toLowerCase().includes("completed") ||
          option.label.toLowerCase().includes("agreed") ||
          option.label.toLowerCase().includes("disagreed") ||
          option.label.toLowerCase().includes("unable") ||
          option.label.toLowerCase().includes("other") ||
          option.label.toLowerCase().includes("alternate") ||
          option.label.toLowerCase().includes("answered")
      )
      ?.map((option) => option.value),
  };

  return { customStatusOptions, statusMapping };
};

export const convertCustomStatusToActual = (
  customStatusFilter: string[],
  statusMapping: Record<string, string[]>
) => {
  const actualStatusValues: string[] = [];

  customStatusFilter.forEach((customStatus) => {
    if (statusMapping[customStatus]) {
      actualStatusValues.push(...statusMapping[customStatus]);
    }
  });

  return actualStatusValues;
};
